import script from "./AnnotationListPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnotationListPanel.vue?vue&type=script&setup=true&lang=ts"

import "./AnnotationListPanel.vue?vue&type=style&index=0&id=99bb40e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99bb40e4"]])

export default __exports__